<template>
    <div
        class="l-ss-c-completions-offer-group"
        ref="offerGroup">
        <h2
            v-if="offersLabel === 'extraOffers'"
            class="l-ss-c-completions-offer-group-title">
            {{ $t('results.extraOffersTitle') }}
        </h2>

        <div class="l-ss-c-completions-offer-group-inner">
            <div
                class="l-ss-c-completions-offer-item-wrapper"
                v-for="(offer, i) in offers"
                :key="offer.id">
                <offer
                    :is-cart-count-available="$configuration.cartCount.completions.count"
                    :link-target-blank="$configuration.linkTargetBlank"
                    :mobile="$screen.isMobile"
                    :layout="offerLayout"
                    :settings="$configuration.offer"
                    :data-id="offer._id"
                    :data-position="i + 1"
                    :offer="offer"
                    :offer-index="i"
                    @add-to-cart-click="addToCard($event)"
                    @remove-from-cart-click="removeFromCard($event)"/>
            </div>

            <div
                class="l-ss-c-completions-offer-item-wrapper-empty"
                style="height: 100%"
                v-if="offers.length % 2 === 0 && $screen.isMobile">
            </div>
        </div>
    </div>
</template>

<script>
    import Offer from '@/core/components/offer/offer.vue';
    import offerHandlersMixin from '@/core/mixins/offer-handlers';

    export default {
        name: 'completions-item-offer-wrapper',
        components: { Offer },
        mixins: [offerHandlersMixin],
        props: {
            offers: {
                type: Array,
                required: true,
            },
            offerDataset: {
                type: Object,
            },
            offersLabel: {
                type: String,
            },
            query: {
                type: String,
                default: '',
            },
        },
        data() {
            return {};
        },
        computed: {
            offerLayout() {
                return !this.$screen.isMobile ? 'rowMini' : 'columnMini';
            },
            breakpoint() {
                return {
                    columnCount: this.offerLayout === 'rowMini' ? 1 : 2,
                };
            },
        },
    };
</script>

<style scoped>

</style>
